<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Users' : 'Deleted Users'"
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/users/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/users/upload"
                >
                  <v-icon dark> mdi-upload </v-icon>
                </v-btn>
              </section>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    ref="position"
                    v-model="filter.position_id"
                    :items="positions"
                    label="Position"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-account"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="users.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">First Name</th>
                      <th class="text-left">Middle Name</th>
                      <th class="text-left">Last Name</th>
                      <th class="text-left">User Name</th>
                      <th class="text-left">Email</th>
                      <th class="text-left">Phone</th>
                      <th class="text-left">Position</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="users.length != 0">
                    <tr v-for="(user, i) in users" :key="`user${i}`">
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="user.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>User is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="user.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>User is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>{{ user.first_name || "" }}</td>
                      <td>{{ user.middle_name || "" }}</td>
                      <td>{{ user.last_name || "" }}</td>
                      <td>{{ user.user_name || "" }}</td>
                      <td>{{ user.email || "" }}</td>
                      <td>{{ user.phone || "" }}</td>
                      <td>
                        {{ user.position ? user.position.name : "" }}
                      </td>

                      <td
                        class="text-right"
                        style="white-space: nowrap; max-width: 150px"
                      >
                        <template v-if="!isDeletePage()">
                          <!-- View KYC Button -->
                          <v-tooltip bottom v-if="user.position_id !== 2">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mx-1 mb-1"
                                fab
                                x-small
                                color="primary"
                                :to="`/users/${encryptIt(
                                  user.id
                                )}/user-kyc-details`"
                              >
                                <v-icon dark>mdi-content-duplicate</v-icon>
                              </v-btn>
                            </template>
                            <span>View KYC Details</span>
                          </v-tooltip>

                          <!-- View Vehicle Documents Button (DELIVERY PARTNER only) -->
                          <v-tooltip bottom v-if="user.position_id === 3">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mx-1 mb-1"
                                fab
                                x-small
                                color="info"
                                @click="viewVehicleDocuments(user.id)"
                              >
                                <v-icon dark>mdi-car-multiple</v-icon>
                              </v-btn>
                            </template>
                            <span>View Vehicle Documents</span>
                          </v-tooltip>

                          <!-- Delete Button -->
                          <!-- <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mx-1 mb-1"
                                fab
                                x-small
                                color="error"
                                @click="Delete_this(user.id)"
                              >
                                <v-icon dark>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this user</span>
                          </v-tooltip> -->

                          <!-- Edit Button -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mx-1 mb-1"
                                fab
                                x-small
                                color="primary"
                                :to="`/users/${encryptIt(user.id)}`"
                              >
                                <v-icon dark>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this user</span>
                          </v-tooltip>
                        </template>

                        <!-- Restore Button (Delete Page) -->
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mx-1 mb-1"
                                fab
                                x-small
                                color="success"
                                @click="Restore_this(user.id)"
                              >
                                <v-icon dark>mdi-delete-restore</v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this user</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="12" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_user" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>User deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_user = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_user" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>User restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_user = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- Vehicle Documents Dialog -->
      <v-dialog v-model="vehicleDocumentsDialog" max-width="900" scrollable>
        <v-card rounded="xxl">
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-car-multiple</v-icon>
            Vehicle Documents
            <v-spacer></v-spacer>
            <v-btn icon dark @click="vehicleDocumentsDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pt-4">
            <section v-if="isLoadingVehicleDocs" style="height: 285px">
              <v-progress-linear
                indeterminate
                color="primary"
              ></v-progress-linear>
            </section>

            <section v-else>
              <div
                v-if="vehicleDocuments.length === 0"
                class="text-center py-5"
              >
                <v-icon size="80" color="grey"
                  >mdi-file-document-outline</v-icon
                >
                <h3 class="mt-3">No vehicle documents found</h3>
              </div>

              <v-row v-else>
                <v-col
                  v-for="(doc, index) in vehicleDocuments"
                  :key="index"
                  cols="12"
                >
                  <v-card outlined class="mb-3">
                    <v-card-title class="subtitle-1">
                      <v-icon left color="info">mdi-car</v-icon>
                      {{
                        doc.vehicleType && doc.vehicleType.name
                          ? doc.vehicleType.name
                          : "Vehicle Document"
                      }}
                      <v-spacer></v-spacer>
                      <v-chip
                        small
                        :color="doc.is_active ? 'success' : 'error'"
                        text-color="white"
                      >
                        {{ doc.is_active ? "Active" : "Inactive" }}
                      </v-chip>
                    </v-card-title>

                    <v-card-text>
                      <v-row>
                        <!-- Driving License -->
                        <v-col cols="12" md="4" v-if="doc.driving_license_path">
                          <div class="text-center">
                            <h4 class="mb-2">Driving License</h4>
                            <v-card
                              outlined
                              class="pa-2"
                              @click="
                                openImagePreview(doc.driving_license_path)
                              "
                              style="cursor: pointer"
                            >
                              <v-img
                                :src="getImageUrl(doc.driving_license_path)"
                                height="150"
                                contain
                                class="grey lighten-2"
                              >
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                  >
                                    <v-progress-circular
                                      indeterminate
                                      color="grey lighten-5"
                                    ></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-card>
                            <v-btn
                              x-small
                              text
                              color="primary"
                              @click="
                                openImagePreview(doc.driving_license_path)
                              "
                              class="mt-1"
                            >
                              <v-icon left small>mdi-eye</v-icon>
                              View
                            </v-btn>
                          </div>
                        </v-col>

                        <!-- RC (Registration Certificate) -->
                        <v-col cols="12" md="4" v-if="doc.rc_path">
                          <div class="text-center">
                            <h4 class="mb-2">Registration Certificate</h4>
                            <v-card
                              outlined
                              class="pa-2"
                              @click="openImagePreview(doc.rc_path)"
                              style="cursor: pointer"
                            >
                              <v-img
                                :src="getImageUrl(doc.rc_path)"
                                height="150"
                                contain
                                class="grey lighten-2"
                              >
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                  >
                                    <v-progress-circular
                                      indeterminate
                                      color="grey lighten-5"
                                    ></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-card>
                            <v-btn
                              x-small
                              text
                              color="primary"
                              @click="openImagePreview(doc.rc_path)"
                              class="mt-1"
                            >
                              <v-icon left small>mdi-eye</v-icon>
                              View
                            </v-btn>
                          </div>
                        </v-col>

                        <!-- Insurance Document -->
                        <v-col cols="12" md="4" v-if="doc.insurance_doc_path">
                          <div class="text-center">
                            <h4 class="mb-2">Insurance Document</h4>
                            <v-card
                              outlined
                              class="pa-2"
                              @click="openImagePreview(doc.insurance_doc_path)"
                              style="cursor: pointer"
                            >
                              <v-img
                                :src="getImageUrl(doc.insurance_doc_path)"
                                height="150"
                                contain
                                class="grey lighten-2"
                              >
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                  >
                                    <v-progress-circular
                                      indeterminate
                                      color="grey lighten-5"
                                    ></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-card>
                            <v-btn
                              x-small
                              text
                              color="primary"
                              @click="openImagePreview(doc.insurance_doc_path)"
                              class="mt-1"
                            >
                              <v-icon left small>mdi-eye</v-icon>
                              View
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </section>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="vehicleDocumentsDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Image Preview Dialog -->
      <v-dialog v-model="imagePreviewDialog" max-width="800">
        <v-card>
          <v-card-title class="primary white--text">
            Document Preview
            <v-spacer></v-spacer>
            <v-btn icon dark @click="imagePreviewDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-img :src="previewImageUrl" max-height="600" contain></v-img>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "usersPage",
  data() {
    return {
      filter: {
        active: "",
        supervisor_id: "",
        role_id: "",
        position_id: "",
        show_deleted: false,
      },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      is_deleted_user: false,
      restore_user: false,
      is_restored_user: false,
      users: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      positions: [
        {
          id: 0,
          text: "Select Position",
          value: "",
        },
      ],
      isLoading: false,
      isExcelloading: false,
      ExportUsers: [],
      Export_users: [],
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
        Email: "email",
        Phone: "phone",
        Supervisor: "supervisor",
        "Is Active": "status",
      },
      vehicleDocumentsDialog: false,
      vehicleDocuments: [],
      isLoadingVehicleDocs: false,
      imagePreviewDialog: false,
      previewImageUrl: "",
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=user`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.positions.forEach((position) => {
            this.positions.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async getData() {
      console.log("Get Data");
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&role_id=3" +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&position_id=" +
        this.filter.position_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`users?${query}`)
        .then((response) => {
          this.users = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async Delete_this(id) {
      this.delete_user = true;
      await axios
        .post(`/users/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_user = false;
          this.is_deleted_user = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async addToExcelData() {
      this.isExcelLoading = true;
      this.title = "Company Lists";
      let Export_users = [];
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let query =
        "search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.filter.active +
        "&roleId=" +
        this.filter.role_id;
      Export_users = await axios.get(`users?${query}`);
      this.Export_users = Export_users.data.data;

      this.Export_users.forEach((user) => {
        this.ExportUsers.push({
          sr_no: user.sr_no,
          name: user.name ? user.name.toUpperCase() : "",
          email: user.email ? user.email.toUpperCase() : "",
          phone: user.phone ? user.phone : "",

          supervisor: user.supervisor_id
            ? user.supervisor.name.toUpperCase()
            : "",
          status: user.active == 1 ? "YES" : "NO",
        });
      });
      this.isExcelLoading = false;
    },
    async generateExcel() {
      this.isExcelLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      let response = [];
      let query =
        "role_id=3" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.filter.is_active +
        "&position_id=" +
        this.filter.position_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      response = await axios
        .get(`/users/excel_export?${query}`)
        .then((response) => window.open(`${response.data.data}`, "_blank"));
      if (response) {
        console.log(response);
      }
      this.isExcelloading = false;
    },
    isDeletePage() {
      let response = false;
      if (this.$route.query.open_trash) {
        response = true;
      }
      return response;
    },
    async Restore_this(id) {
      this.restore_user = true;
      await axios
        .post(`/users/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_user = false;
          this.is_restored_user = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async viewVehicleDocuments(userId) {
      this.vehicleDocumentsDialog = true;
      this.isLoadingVehicleDocs = true;
      this.vehicleDocuments = [];

      try {
        const response = await axios.get(
          `/vehicle_documents?user_id=${userId}`
        );
        if (response.data.success) {
          this.vehicleDocuments = response.data.data;
        }
      } catch (error) {
        console.error("Error fetching vehicle documents:", error);
        this.$store.dispatch("errors/push", {
          message: "Failed to fetch vehicle documents",
        });
      } finally {
        this.isLoadingVehicleDocs = false;
      }
    },     
    getImageUrl(path) {
      if (!path) return "";  

      // Skip temp files or invalid paths
      if (path.includes("\\tmp\\") || path.includes("C:\\")) {
        return ""; // Return empty for temp files
      }

      // If path is already a full URL, return it
      if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
      }
      console.log("path", path);

      // For Vultr storage paths, construct the storage URL
      if (path.startsWith("oggykart/")) {
        const storageUrl =
          process.env.VUE_APP_STORAGE_URL ||
          "https://blr1.vultrobjects.com/space-1/";
        console.log(`${storageUrl}${path}`);

        return `${storageUrl}${path}`;
      }

      // Otherwise, construct the full URL based on your API base URL
      const baseUrl =
        process.env.VUE_APP_API_URL || axios.defaults.baseURL || "";
      return `${baseUrl.replace("/api", "")}/${path}`;
    },
    openImagePreview(imagePath) {
      //  this.previewImageUrl = this.getImageUrl(imagePath);
      this.previewImageUrl = this.mediaUrl + imagePath;
      this.imagePreviewDialog = true;
    },
  },
};
</script>
